import React from 'react';
import {SelectModel} from "../../../../../app/types/SelectModel";
import {useTranslation} from "react-i18next";
import GridFilterPanelLayoutCollapse
    from "../../../../uiLayouts/GridFilterPanelLayout/components/GridFilterPanelLayoutCollapse/GridFilterPanelLayoutCollapse";
import cl from "../../AccessSettings/AccessSettings.module.css";
import FilterPanelEquipmentFilterContent from "./FilterPanelEquipmentFilterContent";
import Icon from "../../../../../assets/icon/Icon";
import FilterPanelEquipmentFilterSelectedContainer from "./FilterPanelEquipmentFilterSelectedContainer";

type FilterPanelEquipmentFilterProps = {
    id: string;
    disabled?: boolean;
    onClear: (value?: string) => void;
    onChange: (value: Array<SelectModel>) => void,
    value: Array<SelectModel>;
}

const FilterPanelEquipmentFilter: React.FC<FilterPanelEquipmentFilterProps> = ({
                                                                                   id,
                                                                                   disabled,
                                                                                   onClear,
                                                                                   onChange,
                                                                                   value
                                                                               }) => {
    const {t} = useTranslation();

    return (
        <GridFilterPanelLayoutCollapse defaultExpanded={false}
                                       titleBold={false}
                                       showSeparationHeaderLine={false}
                                       hideOnFilterPanelLayoutContextClear={true}
                                       style={{margin: '5px 0 10px 0'}}
                                       tagsContainer={<FilterPanelEquipmentFilterSelectedContainer id={`${id}-tags`}
                                                                                                   value={value}
                                                                                                   onClear={onClear}/>}
                                       title={
                                           <>
                                               <div>
                                                   {t("shared.labels.equipment")}
                                               </div>
                                               <div>
                                                   {value.length > 0
                                                       ? <Icon icon={"faTrash"}
                                                               className={cl.trash}
                                                               onClick={(ev) => {
                                                                   ev.stopPropagation();

                                                                   if (disabled) {
                                                                       return;
                                                                   }

                                                                   onClear();
                                                               }}/>
                                                       : null
                                                   }
                                               </div>
                                           </>
                                       }>
            {({isExpanded}) =>
                <div>
                    {isExpanded
                        ? <FilterPanelEquipmentFilterContent id={id}
                                                             onChange={onChange}
                                                             value={value}/>
                        : <div style={{height: '250px'}}>
                        </div>
                    }
                </div>
            }
        </GridFilterPanelLayoutCollapse>
    );
};

export default FilterPanelEquipmentFilter;